import React from 'react';
import './styles.css';
import LoginPageWrapper from 'components/shared/containers/LoginPageWrapper';
import MainContentContainer from 'components/shared/containers/MainContentContainer';
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import UITextInput from 'components/ui/UITextInput';
import UIShowHideInput from 'components/ui/UIShowHideInput';
import { Link, BrandingImage, DisabledPrompt, useRoute,BCMSStateManagerCRUD ,StateManager,useStateManager} from "@bcm-dev/bcms-vite";
import UICheckbox from 'components/ui/UICheckbox';
import { UIPrimaryButton, UISecondaryButton } from 'components/ui/UIButton';
import { getDefaultPageData } from 'components/workflows/LoginWorkflow';
/**
 * @function LoginPage
 * @exported true
 * @description This is the login page.
 * @return {React.Component}
 */
 export default function LoginPage(props) {
  // Set the data and ui variables with the default values and whats passed
  // through the properties
  const data = { ...getDefaultPageData(), ...props.data ?? {} };


  // The state that will be passed to the state manager
  const state = { data};
  // :: React.state, React.setState -> OBJECT
  // Function that returns the controller for the state manager
  const controller = (state, setState) => ({
      data: state.data, // Set the data property in the controller
     

      // onEventChange :: STRING, * -> VOID
      // Update the data based on the passed prop and value parameters
      onEventChange: prop => value => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], value)
        .submit(setState);
      },
      update: (prop, val) => {
        BCMSStateManagerCRUD.init(state)
          .update([ "data", prop ], val)
         
          .submit(setState);
      }
  });

  return (
    <StateManager state={ state } controller={ controller }>
      <LoginContent/>
    </StateManager>
  );
}
/**
 * @function LoginContent
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The Login Page
 */

 function LoginContent(props){
  const navigate = useRoute();
  const { data, onEventChange ,update} = useStateManager();
  const onShowHideClick = val =>{
    return update("showPassword", !val);
  }
  const onRememberClick = (evt) => {
  
   return update("rememberUserName", evt.target.checked )
   
  };
console.log(data.rememberUserName)
  return(
    <LoginPageWrapper className="login-page">
        <MainContentContainer>
          <div className="logo-container">
            <BrandingImage id="standalone_fi_logo_chw23" className="institution-logo" alt="Financial Institution Logo" />
          </div>
          <FormContainer>
            <FormRow className="username-container flex-container flex-vertical align-bottom-container">
              <UITextInput placeholder="Username" value ={data.userName} onChange={onEventChange("userName")} />
              <DisabledPrompt>
                <Link>Forgot Username?</Link>
              </DisabledPrompt>
            </FormRow>
            <FormRow className="password-container flex-container flex-vertical align-bottom-container">
              <UIShowHideInput placeholder="Password" revealPassword={ data.showPassword } onShowHideClick={ onShowHideClick }  value ={data.password} onChange={onEventChange("password")}/>
              <DisabledPrompt>
                <Link>Forgot password?</Link>
              </DisabledPrompt>
            </FormRow>
            <FormRow>
              <UICheckbox label="Remember Username" value ={data.rememberUserName} onChange={onRememberClick}/>
            </FormRow>
            <FormButtonContainer>
              <UIPrimaryButton text="Log in" onClick={() => {navigate("/home/recentTransactions")}} />
              <DisabledPrompt>
                <UISecondaryButton text="New User" />
              </DisabledPrompt>
            </FormButtonContainer>
          </FormContainer>
          <div className="grey-section">
            <p className="text-center">First time? Register with "New User"</p>
          </div>
          <div className="sub-text-container">
            <p className="sub-text text-center"> For any issues or concerns <DisabledPrompt><Link>Contact Us</Link></DisabledPrompt></p>
          </div>
          <div className="sub-text-container">
            <p className="sub-text text-center"> By signing in to the application, you agree to the <DisabledPrompt><Link>Terms and Conditions</Link></DisabledPrompt> and <DisabledPrompt><Link>Privacy Policy</Link></DisabledPrompt>.</p>
          </div>
        </MainContentContainer>
    </LoginPageWrapper>
  );
}